import Vue from 'vue'
import VueQriously from 'vue-qriously'
import VueClipboard from 'vue-clipboard2'
import VCalendar from 'v-calendar'
// import { Calendar, DatePicker } from 'v-calendar'
// import Calendar from 'v-calendar/lib/components/calendar.umd'
// import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import VueYoutube from 'vue-youtube'
import VueAnalytics from 'vue-analytics'
import VueEditor from 'vue2-editor'
import * as VueGoogleMaps from 'vue2-google-maps'
import ImageCompressor from 'vue-image-compressor'
// import GoogleAuth from 'vue-google-oauth'
// import 'v-calendar/lib/v-calendar.min.css'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en' // lang i18n

import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'

import '@/icons' // icon
import '@/permission' // permission control

Vue.use(ElementUI, { locale })
Vue.use(VueQriously)
Vue.use(VueClipboard)
Vue.use(VCalendar)
Vue.use(VueEditor)
// Vue.component('calendar', Calendar)
// Vue.component('date-picker', DatePicker)
// import Calendar from 'v-calendar/src/lib';

// Use v-calendar & v-date-picker components
// Vue.use(VCalendar, {
//   componentPrefix: 'vc',
// });
// Vue.component('calendar', Calendar)

Vue.use(VueYoutube)
Vue.use(VueAnalytics, {
  id: 'UA-162786094-1',
  router
})
Vue.use(ImageCompressor)
// Vue.use(GoogleAuth, { client_id: '395371428017-gvb8mqn9fiodirb2ll4k8rp1gngu213f.apps.googleusercontent.com' })
// Vue.googleAuth().load()
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAi2AEvJvSr8o0CLgUjnwILfbACyjnYxtI',
    libraries: 'places',
  },
})

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js